//#region imports
import { Injectable } from '@angular/core';
import { Subject, Observable, BehaviorSubject } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Globals } from './globals';
import { mobileProgressBarModel, ProgressBarModel } from '../shared/model/progressbar.model';
import { ProgressBarService } from './progressbar.service';
import { CharacteristicsComponentModel } from '../module/characteristics/components/characteristics.model';
import { ContactDetailsRequestModel, ContactDetailsResponseModel } from '../shared/model/contactdetails.model';
import { MatDialogConfig, MatDialog } from '@angular/material';
import { ServerFailErrorComponent } from '../shared/components/server-fail-error/server-fail-error.component';
import { AppConstants } from '../app.constants';
//#endregion

@Injectable({
  providedIn: 'root'
})
export class CharacteristicService {
 
  //#region variables
  characteristicsComponentModel: CharacteristicsComponentModel = {
    Question1: true,
    Question2: false,
    Question3: false,
    Question4: false,
    Question5: false
  };
  private federalURL= new Subject<string>();
  p1Screen: boolean;
  executeChkClientIdOrSimulationTokenFirstTime = true;
  private characteristicGroupKey: string;
  private selectedHouse = false;
  private currentSection = new Subject<string>();
  private characteristicsQuestionsSelectedListStr = new Subject<string>();
  private characteristicPreviousQuestionId = new Subject<number>();
  private characteristicChoiceSelected = new Subject<boolean>();
  private characteristicsComponent = new BehaviorSubject<CharacteristicsComponentModel>(this.characteristicsComponentModel);
  private subject = new Subject<any>();
  private showPrevious = new Subject<any>();
  private showLandingPage = new Subject<boolean>();
  private defaultLanguage = new Subject<string>();
  private decryptedClientId: string;
  clientIdOrSimulationTokenPresent: boolean;
  //#endregion

  //#region methods
  constructor(
    private httpClient: HttpClient, private glob: Globals, private matDialog: MatDialog,
    private progressBarService: ProgressBarService) { }

  setCharacteristicCurrentPage(firstPage: boolean, SecondPage: boolean, thirdPage: boolean, fourthPage: boolean, fifthPage: boolean) {
    const characteristicQuestion: CharacteristicsComponentModel = {
      Question1: firstPage, Question2: SecondPage, Question3: thirdPage, Question4: fourthPage, Question5: fifthPage
    };
    this.setCharacteristicsComponent(characteristicQuestion);
  }

  setShowLandingPage(value: boolean) {
    this.showLandingPage.next(value);
  }

  getShowLandingPage(): Observable<boolean> {
    return this.showLandingPage.asObservable();
  }

  setExecuteChkClientIdOrSimulationTokenFirstTime(value: boolean) {
    this.executeChkClientIdOrSimulationTokenFirstTime = value;
  }

  getExecuteChkClientIdOrSimulationTokenFirstTime(): boolean {
    return this.executeChkClientIdOrSimulationTokenFirstTime;
  }

  setFederaleURL(value: string) {
    this.federalURL.next(value);
  }

  getFederaleURL(): Observable<string> {
    return this.federalURL.asObservable();
  }

  setClientIdOrSimulationTokenPresent(value: boolean) {
    this.clientIdOrSimulationTokenPresent = value;
  }

  getClientIdOrSimulationTokenPresent(): boolean {
    return this.clientIdOrSimulationTokenPresent;
  }

  setDefaultLanguage(value: string) {
    this.defaultLanguage.next(value);
  }

  getDefaultLanguage(): Observable<string> {
    return this.defaultLanguage.asObservable();
  }

  setP1Screen(value: boolean) {
    this.p1Screen = value;
  }

  getP1Screen(): boolean {
    return this.p1Screen;
  }

  setDecryptedClientId(value: string) {
    this.decryptedClientId = value;
  }

  getDecryptedClientId(): string {
    return this.decryptedClientId;
  }

  setCharacteristicGroupKey(value: string) {
    this.characteristicGroupKey = value;
  }

  getCharacteristicGroupKey() {
    return this.characteristicGroupKey;
  }

  setCurrentSection(value) {
    this.currentSection.next(value);
  }

  getCurrentSection(): Observable<string> {
    return this.currentSection.asObservable();
  }

  setCharacteristicsComponent(value: CharacteristicsComponentModel) {
    this.characteristicsComponent.next(value);
  }

  getCharacteristicsComponent(): Observable<CharacteristicsComponentModel> {
    return this.characteristicsComponent.asObservable();
  }

  setSelectedHouse(value: boolean) {
    this.selectedHouse = value;
  }

  getSelectedHouse(): boolean {
    return this.selectedHouse;
  }

  setCharacteristicsQuestionsSelectedListStr(value) {
    this.characteristicsQuestionsSelectedListStr.next(value);
  }

  getCharacteristicsQuestionsSelectedListStr(): Observable<string> {
    return this.characteristicsQuestionsSelectedListStr.asObservable();
  }

  setCharacteristicChoiceSelected(value) {
    this.characteristicChoiceSelected.next(value);
  }

  getCharacteristicChoiceSelected(): Observable<boolean> {
    return this.characteristicChoiceSelected.asObservable();
  }

  setCharacteristicPreviousQuestionId(value) {
    this.characteristicPreviousQuestionId.next(value);
  }

  getCharacteristicPreviousQuestionId(): Observable<number> {
    return this.characteristicPreviousQuestionId.asObservable();
  }

  setData(message: any) {
    this.subject.next(message);
  }

  getData(): Observable<any> {
    return this.subject.asObservable();
  }

  setShowPrevious(value: any) {
    this.showPrevious.next(value);
  }

  getShowPrevious(): Observable<any> {
    return this.showPrevious.asObservable();
  }
  getServerTime() {
    return this.httpClient.get<string>(environment.apiURL + AppConstants.APIURLS.GetServerTime);
  }
  getCharacteristicDataApi() {
    const useMock = AppConstants.UseMock;
    if (useMock) {
      return this.httpClient.get<any>(AppConstants.MockURLS.GetSimulation);
    } else {
      const request = { Status: 'Start', Channel: 'WEB', Language: this.glob.languagecode, SimulationType: 'F' };
      return this.httpClient.post<any>(environment.apiURL + AppConstants.APIURLS.GetSimulation, request);
    }
  }

  getNextDataApi(initialJSONResponse) {
    const useMock = AppConstants.UseMock;
    if (useMock) {
      if (this.getSelectedHouse()) {
        return this.httpClient.get<any>(AppConstants.MockURLS.GetNextSimulation2Point1);
      } else {
        return this.httpClient.get<any>(AppConstants.MockURLS.GetNextSimulation2Point2);
      }
    } else {
      const url = environment.apiURL + AppConstants.APIURLS.GetNextSimulation;
      return this.httpClient.post<any>(url, initialJSONResponse);
    }
  }

  getDecryptedClientIdAPI(encryptedClientId: string) {
    const url = environment.apiURL + AppConstants.APIURLS.GetDecryptedId + encryptedClientId;
    return this.httpClient.get<any>(url);
  }

  getContactDetailsFromAPI(contactDetailsRequest: ContactDetailsRequestModel) {
    const useMock = AppConstants.UseMock;
    if (useMock) {
      return this.httpClient.get<ContactDetailsResponseModel>(AppConstants.MockURLS.GetContactDetails);
    } else {
      const url = environment.apiURL + AppConstants.APIURLS.GetContactDetails;
      return this.httpClient.post<ContactDetailsResponseModel>(url, contactDetailsRequest);
    }
  }

  serverFailError(data: any) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.data = data; //{title: 'Error', errorMessage: 'Server is unavailable. Please try after sometime', disableClose: false};
    this.matDialog.open(ServerFailErrorComponent, dialogConfig);
  }

  setCharacteristicProgressBarDetails() {
    const characteristicsProgressStatus: ProgressBarModel = {
      Disable: false, Number: false, Icon: false
    };
    const detailsProgressStatus: ProgressBarModel = {
      Disable: true, Number: true, Icon: false
    };
    const guaranteeProgressStatus: ProgressBarModel = {
      Disable: true, Number: true, Icon: false
    };
    const summaryProgressStatus: ProgressBarModel = {
      Disable: true, Number: true, Icon: false
    };
    const signatureProgressStatus: ProgressBarModel = {
      Disable: true, Number: true, Icon: false
    };
    this.progressBarService.setCharacteristicsProgressStatus(characteristicsProgressStatus);
    this.progressBarService.setDetailsProgressStatus(detailsProgressStatus);
    this.progressBarService.setGauranteeProgressStatus(guaranteeProgressStatus);
    this.progressBarService.setSummaryProgressStatus(summaryProgressStatus);
    this.progressBarService.setSignatureProgressStatus(signatureProgressStatus);
  }

  setmobileCharacteristicProgressBarDetails() {
    const characteristicsProgressStatus: mobileProgressBarModel = {
      Enable: true
    };
    const detailsProgressStatus: mobileProgressBarModel = {
      Enable: false
    };
    const guaranteeProgressStatus: mobileProgressBarModel = {
      Enable: false
    };
    const summaryProgressStatus: mobileProgressBarModel = {
      Enable: false
    };
    const signatureProgressStatus: mobileProgressBarModel = {
      Enable: false
    };
    this.progressBarService.setmobileCharacteristicsProgressStatus(characteristicsProgressStatus);
    this.progressBarService.setmobileDetailsProgressStatus(detailsProgressStatus);
    this.progressBarService.setmobileGauranteeProgressStatus(guaranteeProgressStatus);
    this.progressBarService.setmobileSummaryProgressStatus(summaryProgressStatus);
    this.progressBarService.setmobileSignatureProgressStatus(signatureProgressStatus);
    if (document.getElementById("tab1") !== null && document.getElementById("tab1") !== undefined 
    && document.getElementById("tab2") !== null && document.getElementById("tab2") !== undefined
    && document.getElementById("tab3") !== null && document.getElementById("tab3") !== undefined
    && document.getElementById("tab4") !== null && document.getElementById("tab4") !== undefined
    && document.getElementById("tab5") !== null && document.getElementById("tab5") !== undefined ){
    document.getElementById("tab1").classList.remove("d-none");
    document.getElementById("tab2").classList.remove("d-none");
    document.getElementById("tab3").classList.remove("d-none");
    document.getElementById("tab5").classList.remove("d-none");
    document.getElementById("tab4").querySelector(".panel-heading").classList.remove("d-none");
    }
  }
  //#endregion
}
